module.exports = {
          srcSet: __webpack_public_path__ + "public/images/d9cb229263fbda5542db540bf52ccedf-1920.jpg"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/d9cb229263fbda5542db540bf52ccedf-1920.jpg",width: 1920,height: 1280}],
          src: __webpack_public_path__ + "public/images/d9cb229263fbda5542db540bf52ccedf-1920.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/d9cb229263fbda5542db540bf52ccedf-1920.jpg"},
          
          width: 1920,
          height: 1280
        }